<template>
  <div>
    <Teleport v-if="globalStore.confirmShown" to="body">
      <div class="modal__overlay z-10 fixed top-0 start-0 w-screen h-screen bg-black/40"></div>
      <div
        class="modal__wrapper z-50 fixed top-0 start-0 w-screen h-screen flex justify-center items-center"
        @click.prevent="globalStore.confirmShown = false"
      >
        <div
          :class="containerClass"
          class="modal__container bg-white shadow-lg rounded-md flex flex-col"
          @click.stop.prevent=""
        >
          <slot name="container">
            <slot name="header">
              <div
                class="container__header border-b border-brand-gray-300 px-3 pt-2 pb-1 flex justify-between"
              >
                <HeaderTypo class="text-xl">{{ $t(globalStore.confirmConfig.title) }}</HeaderTypo>
                <button @click="onAnswer(false)"><faTimes class="w-4" /></button>
              </div>
            </slot>
            <slot name="body">
              <div
                class="flex-1 container__body px-3 pt-2 pb-1 ltr:font-sans text-sm text-gray-600"
              >
                <slot name="bodyContent">
                  <p>{{ $t(globalStore.confirmConfig.message) }}</p>
                </slot>
              </div>
            </slot>
            <slot name="footer">
              <div
                class="container__footer px-3 py-2 flex justify-between items-center gap-x-4 border-t border-brand-gray-300"
              >
                <slot name="footerContent">
                  <div></div>
                  <button
                    class="px-1.5 py-0.5 rounded-md bg-gradient-to-tr from-linear-s to-linear-e text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
                    type="submit"
                    @click="onAnswer(true)"
                  >
                    {{ $t(globalStore.confirmConfig.posLabel) }}
                  </button>
                </slot>
              </div>
            </slot>
          </slot>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import faTimes from '@/assets/icons/faTimes.svg?component'
import { useGlobalStore } from '@/stores/global'

const model = defineModel()
defineProps({
  title: String,
  containerClass: {
    type: String,
    default: () => 'w-6/12'
  }
})

const globalStore = useGlobalStore()

globalStore.$subscribe((mutation, state) => {
  document.body.style.overflow = state.confirmShown ? 'hidden' : 'inherit'
})

const onAnswer = (ans) => {
  globalStore.$patch({
    confirmResponse: ans,
    confirmShown: false
  })

  model.value = false
}
</script>

<style lang="scss" scoped></style>
